import * as React from 'react'
import { ModalWindow } from '$views/components/ModalWindow'
import { Text, Block } from '$views/components'
import { Button } from '$views/components/Button'
import { Icon } from '$views/components/Icon'
import { Image } from '$views/components/Image'
import { tagManager } from '$infrastructure/tagManager/tagManager'

const fireIcon = require('$icons/fire.svg')
const caretakerImage = require('$images/paulaPopUp.png')

interface Props {
  onClosePopUp: () => void
  onClickButton: () => void
}

export const IntroductionMessagePopUp: React.SFC<Props> = ({ onClosePopUp, onClickButton }) => {
  const onClickShowProPlans = () => {
    tagManager.push({ event: 'fam', fam_id: 'PopUpProIntroductionMessage' })
    onClickButton()
  }

  return (
    <ModalWindow onClose={onClosePopUp}>
      <Text title as="span">
        Preséntate. Diles qué te hace especial...
      </Text>
      <Text marginTop="base">Y multiplica las opciones de que te seleccionen. Puedes hacerlo si eres PRO.</Text>
      <Block flex justify="center" onlyDesktop>
        <Image src={caretakerImage} width={350} />
      </Block>
      <Block flex justify="center" onlyMobile>
        <Image src={caretakerImage} width={292} />
      </Block>
      <Block marginBottom="medium" flex>
        <Block>
          <Icon content={fireIcon} size="ml" />
        </Block>
        <Block>
          <Text menu as="span">
            ¿Sabías que...? Presentarse aumenta en un{' '}
          </Text>
          <Text menu weight="medium" as="span">
            80% las probabilidades{' '}
          </Text>
          <Text menu as="span">
            de que te contacten por chat.
          </Text>
        </Block>
      </Block>
      <Button primary onClick={onClickShowProPlans}>
        Ver Planes PRO
      </Button>
    </ModalWindow>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/ProPopUp/IntroductionMessagePopUp.tsx